import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../components/Loader/Index";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addNewLabelPvt,
  getAllPrivateTransactions,
  removeNewLabelPvt,
  setTogglePvt,
} from "../../../redux/features/privatetransactions/privatetransactions";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import useCategories from "../../../utils/useCategories";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";

import { resetToggle } from "../../../redux/features/internalTransaction/internalTransactionViewAll";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import SVGComponent from "../../../components/_utils/SVGComponent";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import ListDualText from "../../../components/_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CommonToast from "../../../components/_utils/CommonToast";
import { toast } from "react-toastify";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import ICONS from "../../../assets/Icons";

const PrivateTxnViewAll = ({
  onClose,
  setOpenTransHistory,
  type,
  currentCat,
  setInitialstage,
  setShowDetails,
  setShowLabel,
  setShowAdditionalDetails,
  openTransHistory,
  owner_account_id,
  owner_account_no,
}) => {
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const [dataLoading, setDataLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [accountnumberstate, setaccountnumberstate] = useState(
    type === "private_view_similar" ? owner_account_no : "",
  );
  const [inputData, setInputData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [currentDistributionStatus, setCurrentDistributionStatus] =
    useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [active, setActive] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    type === "private_view_modal" || type === "private_view_similar"
      ? currentCat
      : "",
  );
  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [labelSearchText, setLabelSearchText] = useState([]);
  const [labels, setLabels] = useState([]);
  const [ownerAccId, setOwnerAccId] = useState(
    type === "private_view_similar" ? owner_account_id : "",
  );
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [labelData, setlabelData] = useState([]);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const popupLabels = React.useMemo(() => {
    if (!Array.isArray(labels)) return [];
    return labels.filter((label) => !/[A-Z]/.test(label || ""));
  }, [labels]);

  const dispatch = useDispatch();
  const categoryMapper = useCategories();
  const navigate = useNavigate();

  const {
    allPrivateTransactionsData,
    allPrivateTransactionsLoading,
    togglePvt,
  } = useSelector((state) => state.privatetransactions);
  const services = useSelector((state) => state.refreshToken.services);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const allTxnIds =
    allPrivateTransactionsData?.transaction_requests?.map(
      (t) => t.request_reference_id,
    ) || [];

  const isAllSelected =
    allTxnIds.length > 0 &&
    allTxnIds.every((id) => labelTransactions.includes(id));

  const clearParameterVisibility =
    !!currentStatus ||
    !!currentDistributionStatus ||
    !!currentCategory ||
    !!txnAmountFilter ||
    !!accountnumberstate ||
    !!ownerAccId ||
    !!currentIfscCode ||
    !!searchUserTextDebounce ||
    !!(startDateFilter && endDateFilter) ||
    (Array.isArray(labelSearchText) && labelSearchText.length > 0);

  const handleToggle = (newToggleValue) => {
    if (togglePvt !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
      dispatch(setTogglePvt(newToggleValue));
      // setCurrentPage(1);
    }
  };

  const handleAction = async () => {
    try {
      setDataLoading(true);
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      if (currentStatus) {
        queryParams.status = currentStatus;
      }

      if (currentDistributionStatus) {
        queryParams.distribution_lifecycle_status = currentDistributionStatus;
      }

      if (
        startDateFilter &&
        endDateFilter &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.from_date = convertDate(startDateFilter);
        queryParams.to_date = convertDate(endDateFilter);
      }

      if (ownerAccId && ownerAccId !== "") {
        queryParams.owner_account_id = ownerAccId;
      }

      if (currentIfscCode) {
        queryParams.owner_account_ifsc_code = currentIfscCode;
      }

      if (currentCategory) {
        queryParams.category = currentCategory;
      }

      if (txnAmountFilter) {
        queryParams.amount = txnAmountFilter;
      }

      if (labelSearchText) {
        queryParams.labels = labelSearchText;
      }

      let main = await dispatch(getAllPrivateTransactions(queryParams));

      setLabels(main?.payload?.summary?.available_labels);
      setTotalBalanceAmount(Number(main?.payload?.total_amount || 0));
      setDataLoading(false);
    } catch (error) {
      setTotalBalanceAmount(0);
      setDataLoading(false);
    }
  };

  const onMount = () => {
    setCurrentPage(1);
    dispatch(resetToggle());
    // handleAction();
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const convertDate = (timestampInSeconds) => {
    if (!timestampInSeconds) return "";

    const date = new Date(Number(timestampInSeconds) * 1000);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(date.getTime() / 1000);

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(displayDate(start));
      setEndDateFilter(displayDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleStatusChange = (selectedLabel) => {
    switch (selectedLabel) {
      case "Processing":
        setCurrentStatus("processing");
        break;
      case "Validation pending":
      case "Require validation":
        setCurrentStatus("created");
        break;
      case "Require approval":
        setCurrentStatus("require approval");
        break;
      case "Approval pending":
      case "Pending":
        setCurrentStatus("pending");
        break;
      case "Process failed":
        setCurrentStatus("failed");
        break;
      case "Authentication pending":
      case "Require authentication":
        setCurrentStatus("pending_for_otp");
        break;
      case "Approval rejected":
        setCurrentStatus("rejected");
        break;
      case "Validation rejected":
        setCurrentStatus("cancelled");
        break;
      case "Authenticated":
        setCurrentStatus("approved");
        break;
      case "Blocked":
        setCurrentStatus("blocked");
        break;
      default:
        setCurrentStatus("");
        break;
    }
  };

  const getDisplayStatus = (status = "") => {
    switch (status) {
      case "processing":
        return "Processing";
      case "created":
        return services?.includes("ValidatorPrivateTransaction")
          ? "Require validation"
          : "Validation pending ";
      case "Require approval":
        return "Require approval";
      case "pending":
        return services?.includes("APrivateTransaction")
          ? "Pending"
          : "Approval pending";
      case "failed":
        return "Process failed";
      case "pending_for_otp":
      case "otp_requested":
      case "otp_submitted":
        return services?.includes("OTPPrivateTransaction")
          ? "Require authentication"
          : "Authentication pending";
      case "rejected":
        return "Approval rejected";
      case "cancelled":
        return "Validation rejected";
      case "approved":
        return "Authenticated";
      case "blocked":
        return "Blocked";
      default:
        return status || "";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "uploaded":
        return "var(--queued)";
      case "created":
        return "var(--pending)";
      case "pending":
        return "var(--pending)";
      case "failed":
        return "var(--failed)";
      case "pending_for_otp":
      case "otp_requested":
      case "otp_submitted":
        return "var(--pending)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "cancelled":
        return "var(--failed)";
      case "approved":
        return "var(--awaiting)";
      default:
        return "var(--text-primary)";
    }
  };

  const handleDistributionChange = (selectedLabel) => {
    switch (selectedLabel) {
      case "Distribution created":
        setCurrentDistributionStatus("created");
        break;
      case "Awaiting funds":
        setCurrentDistributionStatus("awaiting_funds");
        break;
      case "Distribution initiated":
        setCurrentDistributionStatus("distribution_initiated");
        break;
      case "Distribution rejected":
        setCurrentDistributionStatus("rejected");
        break;
      case "Distribution complete":
        setCurrentDistributionStatus("distribution_complete");
        break;
      case "Abandoned":
        setCurrentDistributionStatus("abandoned");
        break;
      case "Failed":
        setCurrentDistributionStatus("failed");
        break;
      default:
        setCurrentDistributionStatus("");
        break;
    }
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "created":
        return "Distribution created";
      case "awaiting_funds":
        return "Awaiting funds";
      case "distribution_initiated":
        return "Distribution initiated";
      case "rejected":
        return "Distribution rejected";
      case "distribution_complete":
        return "Distribution complete";
      case "abandoned":
        return "Abandoned";
      case "failed":
        return "Failed";
      default:
        return status || "";
    }
  };

  const getDistributionColor = (distribution_lifecycle_status) => {
    switch (distribution_lifecycle_status) {
      case "created":
        return "var(--queued)";
      case "awaiting_funds":
        return "var(--queued)";
      case "distribution_initiated":
        return "var(--queued)";
      case "distribution_complete":
        return "var(--settled)";
      case "abandoned":
        return "var(--abandoned)";
      case "failed":
        return "var(--queued)";
      default:
        return "var(--text-primary)";
    }
  };

  const handleSelectAll = () => {
    const txns = allPrivateTransactionsData?.transaction_requests || [];

    const pageIds = txns
      .slice(0, pageSize)
      .map((item) => item.request_reference_id);

    const isAllSelected =
      pageIds.length && pageIds.every((id) => labelTransactions.includes(id));

    setisLabelClicked(true);

    setLabelTransactions((prev) => {
      if (isAllSelected) {
        return prev.filter((id) => !pageIds.includes(id));
      }

      return Array.from(new Set([...prev, ...pageIds]));
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      handleAction();
    }
  };

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setCurrentPage(1);
    setSearchUserTextDebounce("");
    setCurrentStatus("");
    setCurrentDistributionStatus("");
    setCurrentCategory("");
    setTxnAmountFilter("");
    setLabelSearchText([]);
    setaccountnumberstate("");
    setOwnerAccId("");
    setCurrentIfscCode("");
    setStartDateFilter("");
    setEndDateFilter("");
    if (type === "private_view_similar") {
      setCurrentCategory(currentCat);
      setaccountnumberstate(owner_account_no);
      setOwnerAccId(owner_account_id);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setDataLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);

    const res = await dispatch(
      addNewLabelPvt({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabelPvt.fulfilled.match(res)) {
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setDataLoading(false);
    if (addNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setDataLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);
    const res = await dispatch(
      removeNewLabelPvt({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelPvt.fulfilled.match(res)) {
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setDataLoading(false);
    if (removeNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  // useEffect(() => {
  //   onMount();
  // }, []);

  useEffect(() => {
    handleAction();
  }, [
    currentPage,
    pageSize,
    togglePvt,
    currentStatus,
    currentDistributionStatus,
    startDateFilter,
    endDateFilter,
    accountnumberstate,
    currentIfscCode,
    currentCategory,
    txnAmountFilter,
    labelSearchText,
    markerData,
  ]);
  useEffect(() => {
    let response;
    let data;
    (async () => {
      switch (active) {
        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data = response?.payload?.categories?.map((itm) => {
            return {
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            };
          });
          setInputData(data);
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          setDataLoading(false);
          break;

        case "Labels":
          data = labels
            ?.filter((itm) => {
              if (itm.includes(searchUserTextDebounce)) return itm;
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;
      }
    })();
  }, [active]);

  return (
    <>
      {/* Main code  */}
      <div
        id="beneScrollContainer"
        className={`bg-primary-bg flex flex-col webview relative  ${
          type === "private_view_modal" || type === "private_view_similar"
            ? "h-full  Qsmd:pb-padding-base pb-pagination-padding-top"
            : ""
        } `}
      >
        <div
          className={`absolute rounded-none bg-primary-nav z-z-index-modal bottom-bottom-base w-full ${allPrivateTransactionsData?.transaction_requests?.length > GlobalConfiguration?.lengthCheckOne && !allPrivateTransactionsLoading ? "block" : "hidden"}  ${
            type === "private_view_modal"
              ? "rounded-none bottom-bottom-sm w-pagination-width rounded-b-border-radius-md"
              : type === "private_view_similar"
                ? "rounded-none bottom-bottom-base"
                : "bottom-bottom-base w-full rounded-none"
          } ${showInnerSearchBar && "overflow-y-hidden pointer-events-none"}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div className="block">
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={allPrivateTransactionsData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              typePopup={
                type === "private_view_modal" || type === "private_view_similar"
              }
              setIsOpen={setIsOpen}
            />
          </div>
        </div>

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={popupLabels}
              setLabels={setLabels}
              LabelAccounts={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={(
                allPrivateTransactionsData?.transaction_requests || []
              )
                .filter((acc) => {
                  const currentId = acc?.request_reference_id;

                  return Array.isArray(labelTransactions)
                    ? labelTransactions.includes(currentId)
                    : labelTransactions === currentId;
                })
                .map((acc) => ({
                  ...acc,
                  id: acc?.request_reference_id,
                }))}
              loading={dataLoading}
              setLoading={setDataLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}

        {/* Main code start here  */}
        <div
          className={`bg-primary-bg flex flex-col ${
            type === "private_view_modal" || type === "private_view_similar"
              ? "h-full"
              : "h-screen"
          }`}
          id="benetxnmain"
        >
          <div
            className={`${type === "private_view_modal" || type === "private_view_similar" ? "hidden" : ""} Qmd:min-h-navbar-breadcrumb-height bg-primary-nav`}
          ></div>

          <div className="z-z-index-overlay">
            <TopNavComponent
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              handleBack={() => {
                if (isLabelClicked) {
                  setisLabelClicked(false);
                } else {
                  navigate(-1);
                }
              }}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length > 0
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        // setLabelTransactions([]);
                        // setisLabelClicked(false);
                        if (labelTransactions?.length > 0) {
                          setLabelTransactions([]);
                        } else {
                          setisLabelClicked(false);
                          // navigate(-1);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                    }
                  : undefined
              }
              ispagination={true}
              topNavCtaBtn2Needed={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: allPrivateTransactionsLoading
                        ? "var(--text-disabled)"
                        : labelTransactions?.length
                          ? "var(--text-primary)"
                          : "var(--text-disabled)",
                      handleFunction: (e) => {
                        if (!allPrivateTransactionsLoading) {
                          e.stopPropagation();
                          if (!labelTransactions.length) return;
                          setIsLabelPopupOpen(true);
                        }
                      },
                      enabledTextColor: allPrivateTransactionsLoading
                        ? "var(--text-primary)"
                        : labelTransactions?.length
                          ? "var(--primary-bg)"
                          : "var(--text-primary)",
                      isDisabled:
                        !labelTransactions?.length ||
                        allPrivateTransactionsLoading,
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              isSelectionView={isLabelClicked}
              selectionText={
                isLabelClicked
                  ? `Transaction selected: ${labelTransactions?.length}`
                  : ""
              }
              BottomSubTextVaraint="primary"
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : undefined
              }
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: "Select all",
                      enabledBgColor: "var(--primary-nav-act)",
                      isDisabled: allPrivateTransactionsLoading,
                      handleFunction: (e) => {
                        if (allPrivateTransactionsLoading) {
                          return;
                        }
                        e.stopPropagation();
                        if (
                          allPrivateTransactionsData?.transaction_requests
                            ?.length
                        ) {
                          handleSelectAll();
                        }
                      },
                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",
                      icon: isAllSelected
                        ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                        : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                      fullWidthRequired: false,
                      hoverOption: "white",
                    }
                  : {
                      enabledBgColor: "var(--text-primary)",
                    }
              }
              isToggleNeeded={true}
              toggleProps={{
                state: togglePvt,
                title: togglePvt ? "Grid View" : "List View",
                isDisabled: false,
                handleClick: () => {
                  handleToggle(!togglePvt);
                },
              }}
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                isSearchDisabled: allPrivateTransactionsLoading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search private transactions",
                filterPlaceholder:
                  "name / contact number / email ID / account ID",
                filterItems: [
                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: accountnumberstate,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: setaccountnumberstate,
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled:
                      allPrivateTransactionsLoading ||
                      type === "private_view_similar"
                        ? true
                        : false,
                  },
                  {
                    name: "Category",
                    short_name: "Cat",
                    valueType: "string",
                    isMulti: false,
                    value: currentCategory,
                    setValue: setCurrentCategory,
                    isDropdown: true,
                    isDisabled:
                      type === "private_view_modal" ||
                      type === "private_view_similar"
                        ? true
                        : allPrivateTransactionsLoading
                          ? true
                          : false,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelSearchText,
                    setValue: setLabelSearchText,
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: allPrivateTransactionsLoading ? true : false,
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: setTxnAmountFilter,
                    displayValue: FormatAmount({ price: txnAmountFilter }),
                    isDropdown: false,
                    isDisabled: allPrivateTransactionsLoading ? true : false,
                    valueType: "number",
                  },
                ],
                isSearchClearAllDisabled:
                  type === "private_view_modal" ||
                  type === "private_view_similar"
                    ? true
                    : allPrivateTransactionsLoading
                      ? true
                      : false,
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayStatus(currentStatus),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      currentDistributionStatus?.length > 0 ? true : false,
                    options: services?.includes("APrivateTransaction")
                      ? [
                          "Processing",
                          "Process failed",
                          services?.includes("ValidatorPrivateTransaction")
                            ? "Require validation"
                            : "Validation pending",
                          "Validation rejected",
                          "Require approval",
                          "Pending",
                          "Approval rejected",
                          services?.includes("OTPPrivateTransaction")
                            ? "Require authentication"
                            : "Authentication pending",
                          "Authenticated",
                          "Blocked",
                        ]
                      : [
                          "Processing",
                          "Process failed",
                          services?.includes("ValidatorPrivateTransaction")
                            ? "Require validation"
                            : "Validation pending",
                          "Validation rejected",
                          "Approval pending",
                          "Approval rejected",
                          services?.includes("OTPPrivateTransaction")
                            ? "Require authentication"
                            : "Authentication pending",
                          "Authenticated",
                          "Blocked",
                        ],
                    statusPop: true,
                    handleChange: handleStatusChange,
                  },
                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentDistributionStatus,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled: currentStatus?.length > 0 ? true : false,
                    options: [
                      "Distribution created",
                      "Awaiting funds",
                      "Distribution initiated",
                      "Distribution rejected",
                      "Distribution complete",
                      "Abandoned",
                    ],
                    statusPop: true,
                    handleChange: handleDistributionChange,
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisable: false,
                    startDate: startDateFilter
                      ? new Date(startDateFilter * 1000)
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(endDateFilter * 1000)
                      : endDateFilter,
                    handleChange: (date) => handleFilterDateRange(date),
                  },
                ],
                isFilterClearAllDisabled: !(
                  (startDateFilter && endDateFilter) ||
                  currentStatus?.length > 0 ||
                  currentDistributionStatus?.length > 0 ||
                  allPrivateTransactionsLoading
                ),
                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: allPrivateTransactionsLoading,
                dataLoading: dataLoading,
                setLoading: (e) => {},
                isShowFilter: true,
                isShowSortBy: false,
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        type === "private_view_modal" ||
                        type === "private_view_similar"
                          ? true
                          : false,
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (
                          type === "private_view_modal" ||
                          type === "private_view_similar"
                        ) {
                          toast.dismiss();
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--processing)",
                          });
                        } else if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          setisLabelClicked((prev) => {
                            if (prev) setLabelTransactions([]);
                            return !prev;
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                      hoverOption: "white",
                      disabledBgColor: "var(--primary-bg)",
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          {/* Card section  */}
          <div
            className={`beneTxnViewAll_middle_section_container mx-auto webViewRejectAll`}
          ></div>
          <div
            ref={scrollContainerRef}
            id="benetxnViewallScrollContainer"
            className={`${allPrivateTransactionsLoading && allPrivateTransactionsData?.transaction_requests?.length ? "overflow-y-hidden" : showInnerSearchBar ? "overflow-y-hidden pointer-events-none" : "overflow-y-auto"} ${
              isLabelClicked
                ? "Qsmd:mb-[var(--pagination-height)] mb-topnav-bottom-height"
                : "mb-[var(--pagination-height)]"
            }`}
          >
            {allPrivateTransactionsLoading ? (
              <div className="loader-container m-auto flex items-center justify-center">
                <Loader />
              </div>
            ) : allPrivateTransactionsData?.transaction_requests?.length ? (
              <div
                className={`flex flex-col items-center w-full z-z-index-base  `}
                style={{
                  opacity: "var(--base-opacity)",
                  marginBottom: "var(--margin-base)",
                }}
              >
                <div
                  className={`${
                    !togglePvt
                      ? "standard-card-alignment"
                      : "standard-list-view-alignment"
                  } gap-x-gap-sm gap-y-gap-sm flex-1`}
                >
                  {allPrivateTransactionsData?.transaction_requests.map(
                    (transactions) =>
                      !togglePvt ? (
                        <CardContainer
                          filterRef={scrollContainerRef}
                          hoverHeight={
                            GlobalConfiguration?.privateTxnCardHoverHeightWithoutAmount
                          }
                          key={transactions?.request_reference_id}
                          onClickHandler={() => {
                            if (isLabelClicked) {
                              const isAlreadySelected =
                                labelTransactions.includes(
                                  transactions.request_reference_id,
                                );

                              if (isAlreadySelected) {
                                setLabelTransactions(
                                  labelTransactions.filter(
                                    (id) =>
                                      id !== transactions.request_reference_id,
                                  ),
                                );
                              } else {
                                setLabelTransactions([
                                  ...labelTransactions,
                                  transactions.request_reference_id,
                                ]);
                                setlabelData([...labelData, transactions]);
                              }

                              return;
                            }
                            const options =
                              transactions?.request_status === "pending" &&
                              services?.includes("APrivateTransaction")
                                ? {
                                    replace: openTransHistory ? true : false,
                                    state:
                                      currentStatus === "require approval"
                                        ? "require approval"
                                        : transactions?.request_status,
                                  }
                                : {
                                    replace: openTransHistory ? true : false,
                                  };

                            navigate(
                              `/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/${transactions?.request_reference_id}`,
                              options,
                            );
                            if (openTransHistory) {
                              onClose();
                            }
                            if (type === "private_view_modal") {
                              setInitialstage("details");
                              setShowDetails(true);
                              setShowLabel(false);
                              setShowAdditionalDetails(false);
                              setOpenTransHistory(false);
                            }
                          }}
                          isSelected={
                            Array.isArray(labelTransactions) &&
                            labelTransactions.includes(
                              transactions.request_reference_id,
                            )
                          }
                        >
                          <card-body>
                            {transactions?.total_amount ? (
                              <TextWithIcon
                                type="Amount"
                                fontWeight="semibold"
                                text={transactions?.total_amount}
                                subText="Total transaction amount"
                                textColor="var(--settled)"
                                iconComponentArray={
                                  isLabelClicked &&
                                  transactions?.distribution_lifecycle_status !==
                                    "distribution_complete"
                                    ? [
                                        {
                                          icon: labelTransactions.includes(
                                            transactions?.request_reference_id,
                                          )
                                            ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                            : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                                          isDisabled: false,
                                        },
                                      ]
                                    : []
                                }
                              />
                            ) : (
                              <TextWithIcon
                                type="Text"
                                fontWeight="semibold"
                                text="N/A"
                                subText="Total transaction amount"
                                textColor="var(--settled)"
                                iconComponentArray={
                                  isLabelClicked &&
                                  transactions?.distribution_lifecycle_status !==
                                    "distribution_complete"
                                    ? [
                                        {
                                          icon: labelTransactions.includes(
                                            transactions?.request_reference_id,
                                          )
                                            ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                            : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                                          isDisabled: false,
                                        },
                                      ]
                                    : []
                                }
                              />
                            )}

                            <TextWithIcon
                              text={
                                transactions?.total_beneficiary_account_count ||
                                "N/A"
                              }
                              type="Text"
                              subText="Total beneficiary accounts"
                              fontWeight="normal"
                              textColor="var(--text-primary)"
                            />

                            <TextWithBank
                              text={
                                transactions?.created_at
                                  ? formatDateViewAll(
                                      transactions.created_at,
                                      false,
                                      false,
                                    )
                                  : "Not given"
                              }
                              subText="Created on"
                              type="Text"
                              src={categoryMapper(transactions?.category)}
                            />
                          </card-body>

                          <card-hover>
                            <TextWithIcon
                              text={
                                currentStatus === "require approval" &&
                                transactions?.request_status === "pending"
                                  ? "Require Approval"
                                  : getDisplayStatus(
                                      transactions?.request_status,
                                    )
                              }
                              subText="Approval status"
                              textCase="capitalize"
                              fontWeight="semibold"
                              textColor={
                                transactions?.request_status === "N/A"
                                  ? "var(--text-primary)"
                                  : getStatusColor(transactions?.request_status)
                              }
                            />

                            <TextWithIcon
                              text={getDisplayDistributionStatus(
                                transactions?.distribution_lifecycle_status ||
                                  "N/A",
                              )}
                              subText="Distribution status"
                              textCase="capitalize"
                              fontWeight="semibold"
                              textColor={
                                transactions?.distribution_lifecycle_status ===
                                "N/A"
                                  ? "var(--text_primary)"
                                  : getDistributionColor(
                                      transactions?.distribution_lifecycle_status,
                                    )
                              }
                            />

                            <TextWithIcon
                              text={
                                transactions?.labels?.length
                                  ? transactions.labels.join(", ")
                                  : "No labels assigned"
                              }
                              fontWeight="normal"
                              textColor="var(--text-primary)"
                              iconComponentArray={[
                                {
                                  icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                                },
                              ]}
                            />
                          </card-hover>
                        </CardContainer>
                      ) : (
                        <ListContainer
                          filterRef={scrollContainerRef}
                          key={transactions?.request_reference_id}
                          hoverHeight={
                            GlobalConfiguration?.privateTxnListHoverHeight
                          }
                          onClickHandler={() => {
                            if (isLabelClicked) {
                              const isAlreadySelected =
                                labelTransactions.includes(
                                  transactions.request_reference_id,
                                );

                              if (isAlreadySelected) {
                                setLabelTransactions(
                                  labelTransactions.filter(
                                    (id) =>
                                      id !== transactions.request_reference_id,
                                  ),
                                );
                              } else {
                                setLabelTransactions([
                                  ...labelTransactions,
                                  transactions.request_reference_id,
                                ]);
                                setlabelData([...labelData, transactions]);
                              }
                              return;
                            }
                            const options =
                              transactions?.request_status === "pending" &&
                              services?.includes("APrivateTransaction")
                                ? {
                                    replace: openTransHistory ? true : false,
                                    state:
                                      currentStatus === "require approval"
                                        ? "require approval"
                                        : transactions?.request_status,
                                  }
                                : {
                                    replace: openTransHistory ? true : false,
                                  };

                            navigate(
                              `/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/${transactions?.request_reference_id}`,
                              options,
                            );
                            if (openTransHistory) {
                              onClose();
                            }
                            if (type === "private_view_modal") {
                              setInitialstage("details");
                              setShowDetails(true);
                              setShowLabel(false);
                              setShowAdditionalDetails(false);
                              setOpenTransHistory(false);
                            }
                          }}
                          isSelected={
                            Array.isArray(labelTransactions) &&
                            labelTransactions.includes(
                              transactions.request_reference_id,
                            )
                          }
                        >
                          <list-body>
                            <div className="w-full pr-padding-sm py-padding-xs">
                              <div className="flex flex-col gap-gap-sm">
                                <div className="flex items-center justify-between">
                                  <div className="flex flex-1 gap-gap-sm items-center border-r border-primary-bg">
                                    <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-r-border-radius-md py-padding-xs px-padding-sm">
                                      <SVGComponent
                                        url={categoryMapper(
                                          transactions?.category,
                                        )}
                                        height={"var(--icon-md)"}
                                        width={"var(--icon-md)"}
                                        // color="var(--Custom_Category_Brown)"
                                      />
                                    </div>
                                    <p className="text-settled text-font-xs flex flex-1 font-semibold tracking-letter-space pr-padding-sm">
                                      {transactions?.total_amount ? (
                                        <>
                                          INR{" "}
                                          <FormatAmount
                                            price={Number(
                                              transactions?.total_amount,
                                            )}
                                          />
                                        </>
                                      ) : (
                                        "N/A"
                                      )}
                                    </p>
                                  </div>
                                  <div className="flex gap-gap-sm">
                                    <p className="text-text-primary text-font-xs font-normal pl-padding-sm">
                                      {transactions?.created_at
                                        ? formatDateViewAll(
                                            transactions.created_at,
                                            false,
                                            false,
                                          )
                                        : "Not given"}
                                    </p>
                                    {isLabelClicked &&
                                    transactions?.distribution_lifecycle_status !==
                                      "distribution_complete" ? (
                                      <SVGComponent
                                        url={
                                          labelTransactions.includes(
                                            transactions?.request_reference_id,
                                          )
                                            ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                            : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                                        }
                                        height={"var(--icon-sm)"}
                                        width={"var(--icon-sm)"}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <p className="text-text-primary font-normal text-font-xs pl-padding-sm">
                                  {transactions?.total_beneficiary_account_count ||
                                    "N/A"}{" "}
                                  accounts
                                </p>
                              </div>
                            </div>
                          </list-body>

                          <list-hover>
                            <ListDualText
                              text1={
                                currentStatus === "require approval" &&
                                transactions?.request_status === "pending"
                                  ? "Require Approval"
                                  : getDisplayStatus(
                                      transactions?.request_status,
                                    )
                              }
                              subtext1="Approval status"
                              textCase1="capitalize"
                              text1FontWeight="semibold"
                              text1Color={
                                transactions?.request_status === "N/A"
                                  ? "var(--text-primary)"
                                  : getStatusColor(transactions?.request_status)
                              }
                              text2={getDisplayDistributionStatus(
                                transactions?.distribution_lifecycle_status ||
                                  "N/A",
                              )}
                              subtext2="Distribution status"
                              textCase2="capitalize"
                              text2FontWeight="semibold"
                              text2Color={
                                transactions?.distribution_lifecycle_status ===
                                "N/A"
                                  ? "var(--text-primary)"
                                  : getDistributionColor(
                                      transactions?.distribution_lifecycle_status,
                                    )
                              }
                            />

                            <ListTextWithIcon
                              type="text"
                              text={
                                transactions?.labels?.length
                                  ? transactions.labels.join(", ")
                                  : "No labels assigned"
                              }
                              iconComponentArray={[
                                {
                                  icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                                },
                              ]}
                            />
                          </list-hover>
                        </ListContainer>
                      ),
                  )}
                </div>
              </div>
            ) : (
              <div
                className={`flex flex-col items-center justify-center m-auto  Qsmd:mt-[unset] mt-margin-md h-screen `}
              >
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  {clearParameterVisibility ? (
                    <div>
                      <PrimaryButton
                        enabledBgColor="var(--primary-nav-act)"
                        btnText="Clear parameters"
                        btnType="button"
                        handleFunction={handleClearParams}
                        enabledTextColor="var(--text-primary)"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Main code start here  */}
      </div>
    </>
  );
};

export default PrivateTxnViewAll;
